import React from 'react';
import { gql } from '@apollo/client';
import { useLocalization } from '../../../../../../../../util/useLocalization';
import { AdminEntityMergeRequestItemProps } from '../../AdminEntityMergeRequestItem';
import AdminMergeItemBasicField from '../../components/basicField/AdminMergeItemBasicField';
import { MergeItemAffiliationNotesFragment } from '../../../../../../../../../gql/typings';
import { Locale } from '../../../../../../../../../localization/LocalizationKeys';


const AdminMergeItemAffiliationNotes: React.FC<AdminEntityMergeRequestItemProps> = (props) => {
  const info = props.item.type as MergeItemAffiliationNotesFragment;
  const localization = useLocalization();

  return (
    <AdminMergeItemBasicField {...props}>
      {localization.pluralMessage(Locale.Text.Merge_request_notes_move_description, info.noteIds.length)}
    </AdminMergeItemBasicField>
  );
};

gql`
  fragment MergeItemAffiliationNotes on AffiliationNotes_EntityDataToBeTransferredType {
    code
    entityType
    noteIds
  }
`;

export default AdminMergeItemAffiliationNotes;
